module.exports = __webpack_public_path__ + "b-lite-1-after.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/b-lite-1-after.png
// module id = 1852
// module chunks = 0